import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell, Popup } from 'semantic-ui-react';
import { FiCheckCircle, FiMinusCircle } from 'react-icons/fi';

import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { makeSelectSprayEventForSubmissionFinalSpray } from 'services/sprayEventsForSubmission/selectors';

export interface OwnProps {
    sprayEventId: SprayEventForSubmission['id'];
}

interface ConnectedProps {
    isFinalSpray?: SprayEventForSubmission['sprayEvent']['isFinalSpray'];
}

type Props = OwnProps & ConnectedProps;

export class RenderSubmissionSprayEventsTableRowFinalSprayCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { isFinalSpray } = this.props;

        const notCheckedRender = (
            <Popup
                trigger={
                    <FiMinusCircle
                        size={22}
                        className="text grey"
                        style={{ verticalAlign: 'middle', marginLeft: '-3px' }}
                    />
                }
                content="Not Final Spray"
                inverted
                basic
                position="top center"
            />
        );

        const checkedRender = (
            <Popup
                trigger={
                    <FiCheckCircle
                        size={22}
                        className="text pink"
                        style={{ verticalAlign: 'middle', marginLeft: '-3px' }}
                    />
                }
                content="Final Spray"
                inverted
                basic
                position="top center"
            />
        );

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {isFinalSpray ? checkedRender : notCheckedRender}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isFinalSpray: makeSelectSprayEventForSubmissionFinalSpray()
});

export default connect(mapStateToProps)(
    RenderSubmissionSprayEventsTableRowFinalSprayCellComponent
);
